<template>
  <v-card outlined class="mb-3">
    <v-card-subtitle
      class="d-flex align-center pb-2 clickable"
      @click="dialogLabela = true"
      style="cursor: pointer"
    >
      <v-icon small color="primary" class="mr-2">mdi-label-outline</v-icon>
      <span class="font-weight-bold primary--text">{{ $t("label") }}</span>
      <v-spacer></v-spacer>
      <v-icon small color="primary">mdi-plus-circle</v-icon>
    </v-card-subtitle>
    <v-card-text v-if="editedItem.labels && editedItem.labels.length" class="pt-0">
      <v-chip
        v-for="(label, index) in editedItem.labels"
        :key="index"
        class="mr-2 mb-1"
        close
        small
        @click:close="editedItem.labels.splice(index, 1)"
      >
        {{ label.name }}
      </v-chip>
    </v-card-text>
    <v-card-text v-else class="pt-0">
      <span class="text-caption grey--text">{{ $t("click_to_add_labels") }}</span>
    </v-card-text>

    <standard-dialog
      v-model="dialogLabela"
      :title="$t('label')"
      :max-width="500"
      icon="mdi-label-outline"
      hide-actions
    >
      <v-treeview
        selectable
        activatable
        :items="labels"
        v-model="editedItem.labels"
        return-object
        item-text="name"
        item-key="id"
      ></v-treeview>
    </standard-dialog>
  </v-card>
</template>

<script>
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import labelService from "@/services/label";

export default {
  name: "FoodLabels",
  components: {
    StandardDialog,
  },
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialogLabela: false,
      labels: [],
      loading: false,
    };
  },
  created() {
    this.loadLabels();
  },
  methods: {
    loadLabels() {
      this.loading = true;
      labelService
        .getLabels()
        .then((res) => {
          this.labels = res.data;
        })
        .catch((error) => {
          console.error("Error loading labels:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
